import { commonRequestData, fetchData } from "../../api";

/**
 * Obtiene la lista completa de clientes desde la API.
 *
 * @returns {Promise<Object>} La respuesta de la API con la lista de clientes.
 */
export const traerTodosLosClientes = async () => {
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token).
    };

    // Solicita la lista de clientes usando el endpoint "clientes".
    const response = await fetchData("clientes", requestData);

    // Retorna la respuesta de la API.
    return response;
};

/**
 * Obtiene la información detallada de un cliente específico.
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {number} params.idCliente - ID del cliente a consultar.
 * @returns {Promise<Object>} La respuesta de la API con los detalles del cliente.
 */
export const extraerInformacionCliente = async ({ idCliente }) => {
    const requestData = {
        ...commonRequestData,
        idCliente,
    };

    // Solicita los detalles del cliente usando el endpoint "clientes/informacion".
    const response = await fetchData("clientes/informacion", requestData);

    return response;
};

/**
 * Obtiene la bitácora de un cliente específico.
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {number} params.idCliente - ID del cliente para obtener la bitácora.
 * @returns {Promise<Object>} La respuesta de la API con la bitácora del cliente.
 */
export const extraerBitacoraCliente = async ({ idCliente }) => {
    const requestData = {
        ...commonRequestData,
        idCliente,
    };

    // Solicita la bitácora del cliente usando el endpoint "clientes/bitacora".
    const response = await fetchData("clientes/bitacora", requestData);

    return response;
};

/**
 * Crea un nuevo cliente en la API.
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {Object} params.dataClient - Datos del cliente a crear.
 * @param {number} params.id_admin - ID del administrador que realiza la acción.
 * @param {string} params.name_admin - Nombre del administrador que realiza la acción.
 * @returns {Promise<Object>} La respuesta de la API confirmando la creación del cliente.
 */
export const insertarNuevoCliente = async ({ dataClient, id_admin, name_admin }) => {
    const requestData = {
        ...commonRequestData,
        dataClient,
        id_admin,
        name_admin,
    };

    // Solicita la creación del cliente usando el endpoint "clientes/crear".
    const response = await fetchData("clientes/crear", requestData);

    return response;
};

/**
 * Inserta un nuevo registro en la bitácora de un cliente.
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {number} params.bitacora_cliente - ID del cliente.
 * @param {string} params.bitacora_nombreCliente - Nombre del cliente.
 * @param {number} params.id_admin - ID del administrador que realiza la acción.
 * @param {string} params.name_admin - Nombre del administrador que realiza la acción.
 * @param {string} params.bitacora_detalle - Detalle del registro de la bitácora.
 * @returns {Promise<Object>} La respuesta de la API confirmando la inserción en la bitácora.
 */
export const insertartBitacora = async ({ bitacora_cliente, bitacora_nombreCliente, id_admin, name_admin, bitacora_detalle }) => {
    const requestData = {
        ...commonRequestData,
        bitacora_cliente,
        bitacora_nombreCliente,
        id_admin,
        name_admin,
        bitacora_detalle,
    };

    // Solicita la inserción en la bitácora usando el endpoint "clientes/insertartBitacora".
    const response = await fetchData("clientes/Insertarbitacora", requestData);

    return response;
};

/**
 * Edita un cliente existente en la API.
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {Object} params.dataClient - Datos del cliente a editar.
 * @param {number} params.id_admin - ID del administrador que realiza la acción.
 * @param {string} params.name_admin - Nombre del administrador que realiza la acción.
 * @returns {Promise<Object>} La respuesta de la API confirmando la edición del cliente.
 */
export const insertarEditarCliente = async ({ dataClient, id_admin, name_admin }) => {
    const requestData = {
        ...commonRequestData,
        dataClient,
        id_admin,
        name_admin,
    };

    // Solicita la edición del cliente usando el endpoint "clientes/editar".
    const response = await fetchData("clientes/editar", requestData);

    return response;
};

/**
 * Cambia el estado de un cliente (activo/inactivo).
 *
 * @param {Object} params - Parámetros de la solicitud.
 * @param {Object} params.dataClient - Datos del cliente cuyo estado será cambiado.
 * @param {number} params.id_admin - ID del administrador que realiza la acción.
 * @param {string} params.name_admin - Nombre del administrador que realiza la acción.
 * @param {number} params.valor - Nuevo estado del cliente (1 para activo, 0 para inactivo).
 * @returns {Promise<Object>} La respuesta de la API confirmando el cambio de estado del cliente.
 */
export const updateClientStatusApi = async ({ dataClient, id_admin, name_admin, valor }) => {
    const requestData = {
        ...commonRequestData,
        dataClient,
        id_admin,
        name_admin,
        valor,
    };

    // Solicita el cambio de estado del cliente usando el endpoint "clientes/cambiarestado".
    const response = await fetchData("clientes/cambiarestado", requestData);

    return response;
};




export const ClientesSegunlaempresa = async ({ empresaId }) => {
    const requestData = {
        ...commonRequestData,
        empresaId,
    };

    // Solicita la edición del cliente usando el endpoint "clientes/editar".
    const response = await fetchData("clientes/empresaCliente", requestData);

    return response;
};
